export function initEntryNarrationMessage(): void {
  const triggerButton = document.getElementById('aural_help_message_trigger');
  if (!triggerButton) {
    return;
  }
  const announceText = `
    <div role="application">
      <p>Welcome to Embark, home of the highest rated dog DNA test on the market &#8230; We’ve noticed you’re using assistive technologies to view our site &#8230; To make your experience as seamless as possible, Embark offers dedicated email and phone options for guests using assistive technologies &#8230;</p>
      <p>Our customer success department is available by email at &#8230; <a class="a11y-email" href="mailto:a11y@embarkvet.com">a11y@embarkvet.com</a> &#8230;</p>
      <p>Or phone us at &#8230; <a class="a11y-phone" href="tel:+1(224)236-2275">&#8230; 1 &#8230; 2 2 4 &#8230; 2 3 6 &#8230; 2 2 7 5</a></p>
    </div>`;
  triggerButton.addEventListener('click', (): void => {
    insertLiveRegionText(announceText);
  });
}

export function insertLiveRegionText(announceText: string): void {
  const liveRegion = document.getElementById('screen-reader-live-region');
  if (!liveRegion) {
    return;
  }
  liveRegion.innerHTML = announceText;
}
